<section class="pr-detail-page" *ngIf="pressRelease as pr">

  <!-- HERO -->
  <div class="pr-detail-hero">
    <div class="pr-detail-hero__inner">
      <a routerLink="/newsroom" class="pr-back">← Back to Newsroom</a>
      <div class="pr-detail-meta">
        <span class="pr-detail-tag">Press Release</span>
        <span class="pr-detail-date">{{ pr.date | date:'MMMM d, yyyy' }}</span>
      </div>
      <h1>{{ pr.title }}</h1>
      <p class="pr-detail-summary">{{ pr.summary }}</p>
    </div>
  </div>

  <!-- CONTENT -->
  <div class="pr-detail-body">
    <div class="pr-detail-container">
      <div class="pr-detail-content">
        <markdown [data]="pr.content"></markdown>
      </div>

      <!-- SHARE + CTA -->
      <div class="pr-detail-footer">
        <app-social-share></app-social-share>

        <div class="pr-detail-ctas">
          <a routerLink="/donate" class="pr-cta-btn pr-cta-btn--primary">Support the Campaign</a>
          <a routerLink="/issues" class="pr-cta-btn pr-cta-btn--secondary">Our Platform</a>
          <a routerLink="/newsroom" class="pr-cta-btn pr-cta-btn--ghost">← All Press Releases</a>
        </div>
      </div>
    </div>
  </div>

</section>

<section class="pr-detail-notfound" *ngIf="!pressRelease">
  <p>Press release not found.</p>
  <a routerLink="/newsroom">← Back to Newsroom</a>
</section>
